var $body = $("body");
const bulbOffImgOriginal = $(".jobs-bulb-img img").attr("src");
const pushBtnImgOriginal = $(".vacancy-block-push-img img").attr("src");
const jobTriggerImgOriginal = $(".btn-jobs-trigger img").attr("src");
$(document).ready(function () {
  //Mobile Menu
  $(".menu-trigger").on("click", function () {
    $("body").toggleClass("menu--open");
  });

  //Submenu
  // $(".icon-trigger").on("click", function () {
  //   $(this)
  //     .parent()
  //     .toggleClass("active")
  //     .find(".sub-menu")
  //     .slideToggle();
  //   $(this)
  //     .parent()
  //     .siblings("li")
  //     .removeClass("active")
  //     .find(".sub-menu")
  //     .slideUp();
  // });

  // Scroll to link
  if (window.location.hash) scroll(0, 0);
  setTimeout(function () {
    scroll(0, 0);
  }, 1);
  $(function () {
    // Interlinking
    $("a[href^='#']:not([role=button]):not(.navigation a)").on(
      "click",
      function () {
        // e.preventDefault();
        $("html,body").animate(
          {
            scrollTop: $($(this).attr("href")).offset().top - header_height(),
          },
          1000,
          "swing"
        );
      }
    );

    // Section link of other page
    if (window.location.hash) {
      $("html,body").animate(
        {
          scrollTop: $(window.location.hash).offset().top - header_height(),
        },
        1000,
        "swing"
      );
    }
  });

  if ($(".lightbox").length) {
    $(".lightbox").fancybox();
  }

  $(".menu-close").on("click", function () {
    $(this).parent(".sub-menu").parent(".has-sub").removeClass("has-sub--open");
  });

  // Go to top
  $(".goto-top").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 1000);
    return false;
  });
  banner_height();

  $(".navigation li.has-sub>a").on("click", function (event) {
    event.preventDefault();
    if (window.matchMedia("(min-width: 992px)").matches) {
      $(this).parent().siblings("li.has-sub").removeClass("has-sub--open");
      $(this).parent().toggleClass("has-sub--open");
    } else {
      $(this).parent().toggleClass("open").find(".sub-menu").slideToggle();
      $(this)
        .parent()
        .siblings("li")
        .removeClass("open")
        .find(".sub-menu")
        .slideUp();
    }
  });
  //Search Wrapper
  $(".search-btn").on("click", function () {
    $(this).parent(".search-wrapper").toggleClass("search-active");
    return false;
  });
  $(".cta-link, .cta-img").on("click", function () {
    $(this).parent().toggleClass("active");
  });

  $(".cta-wrapper-mobile-trigger").on("click", function () {
    $(".cta-link").trigger("click");
    return false;
  });
  $(".partner-model-trigger").on("click", function () {
    $("html").addClass("partner-model--open");
  });
  //Auther Image animation
  if ($(".author-teaser".length)) {
    var authorImg1 = document.getElementById("active-author1");
    var authorImages1 = [];
    var authorImg2 = document.getElementById("active-author2");
    var authorImages2 = [];
    var authorImg3 = document.getElementById("active-author3");
    var authorImages3 = [];
    $("#img-group1")
      .children("img")
      .each(function () {
        authorImages1.push($(this).attr("src"));
      });
    window.setInterval(function () {
      if ($("#img-group1").length) {
        var newIndex1 =
          authorImages1.indexOf(authorImg1.attributes.src.value) + 1;
        if (newIndex1 > authorImages1.length - 1) {
          newIndex1 = 0;
        }
        authorImg1.src = authorImages1[newIndex1];
      }
    }, 800);

    $("#img-group2")
      .children("img")
      .each(function () {
        authorImages2.push($(this).attr("src"));
      });
    window.setInterval(function () {
      if ($("#img-group2").length) {
        var newIndex2 =
          authorImages2.indexOf(authorImg2.attributes.src.value) + 1;
        if (newIndex2 > authorImages2.length - 1) {
          newIndex2 = 0;
        }
        authorImg2.src = authorImages2[newIndex2];
      }
    }, 800);

    $("#img-group3")
      .children("img")
      .each(function () {
        authorImages3.push($(this).attr("src"));
      });
    window.setInterval(function () {
      if ($("#img-group3").length) {
        var newIndex3 =
          authorImages3.indexOf(authorImg3.attributes.src.value) + 1;
        if (newIndex3 > authorImages3.length - 1) {
          newIndex3 = 0;
        }
        authorImg3.src = authorImages3[newIndex3];
      }
    }, 800);
  }
  // newsletter banner animation
  if ($(".newsletter-banner-img").length) {
    var bannerImg1 = document.getElementById("newsletter-banner-img");
    var bannerImages1 = [];
    $("#banner-img-group-1")
      .children("img")
      .each(function () {
        bannerImages1.push($(this).attr("src"));
      });
    window.setInterval(function () {
      if ($("#banner-img-group-1").length) {
        var newIndex1 =
          bannerImages1.indexOf(bannerImg1.attributes.src.value) + 1;
        if (newIndex1 > bannerImages1.length - 1) {
          newIndex1 = 0;
        }
        bannerImg1.src = bannerImages1[newIndex1];
      }
    }, 800);
  }
  new WOW().init();

  $(".scroll-to-link").on("click", function () {
    var anchor = $(this).attr("href");
    var hash = anchor.substr(anchor.indexOf("#"));
    var elPos = $(hash).position();
    var elParentPos = $(hash).parent().position();
    $(".partner-info-modal .modal-dialog .modal-content").animate(
      {
        scrollTop: elPos.top + elParentPos.top - 70,
      },
      1000
    );
  });

  // code for partner tool image click
  $(".partner-toolbox__img").on("click", function () {
    $(this).parents(".partner-toolbox").toggleClass("partner-toolbox--open");
  });

  $(".partner-logo-block").on("click", function () {
    varPartnerId = $(this).data("partner-id");
    $(".partner-info-box-wrap").removeClass("active");
    $(
      '.partner-info-box-wrap[data-partner-content="' + varPartnerId + '"]'
    ).addClass("active");
  });

  $(".partner-box-close").on("click", function () {
    $(this).parent().removeClass("active");
  });

  $(".jobs-link-block").on("click", function () {
    varjobId = $(this).data("job-id");
    $(".jobs-description").removeClass("active");
    $('.jobs-description[data-job-desc="' + varjobId + '"]').addClass("active");
    if (window.matchMedia("(max-width: 1199px)").matches) {
      if ($(".jobs-description-wrap").length) {
        var jobDescOffSet =
          $(".jobs-description-wrap").offset().top - header_height();
        $("html, body").animate({ scrollTop: jobDescOffSet }, 1000);
      }
    }
  });

  //vacancy block show
  $(".vacancy-block-push-img").on("click", function () {
    var pushBtnOffImg = pushBtnImgOriginal;
    var pushBtnImgSrc = $(this).find("img").attr("src");
    var pushBtnOnSrc = $(this).find("img").data("src");
    if (pushBtnImgSrc === pushBtnOffImg) {
      $(this).find("img").attr("src", pushBtnOnSrc);
    } else {
      $(this).find("img").attr("src", pushBtnOffImg);
    }
    $(this)
      .parents(".author-content")
      .find(".vacancy-block-inner")
      .slideToggle();
  });

  // code benefit-list list show more and less
  if ($(".benefit-list").length) {
    totalItem = $(".benefit-list li").length;
    itemShow = 4;
    $(".benefit-list li:lt(" + itemShow + ")").show();
    $(".btn-more-benefit").click(function () {
      itemShow = itemShow + 4 <= totalItem ? itemShow + 4 : totalItem;
      $(".benefit-list li:lt(" + itemShow + ")").show(300);
      $(".btn-less-benefit").show();
      if (itemShow == totalItem) {
        $(".btn-more-benefit").hide();
      }
      var scrollVal = $(".benefit-list-button").offset().top;
      $("html, body").animate(
        {
          scrollTop: scrollVal,
        },
        1000
      );
    });
    $(".btn-less-benefit").click(function () {
      itemShow = itemShow - 4 < 0 ? 4 : itemShow - 4;
      $(".benefit-list li")
        .not(":lt(" + itemShow + ")")
        .hide(300);
      $(".btn-more-benefit").show();
      $(".btn-less-benefit").show();
      if (itemShow == 4) {
        $(".btn-less-benefit").hide();
      }
      setTimeout(function () {
        var scrollVal = $(".benefit-list-button").offset().top;
        $("html, body").animate(
          {
            scrollTop: scrollVal - (header_height() + 300),
          },
          1000
        );
      }, 300);
    });
  }

  //code for job button
  $(".btn-jobs-trigger").on("click", function () {
    $(this).parents(".jobs-teaser").find(".jobs-teaser-panel").slideToggle();
    var bulbOffImg = bulbOffImgOriginal;
    var bulbSrc = $(this)
      .parents(".jobs-teaser-content")
      .find(".jobs-bulb-img img")
      .attr("src");
    var bulbOnSrc = $(this)
      .parents(".jobs-teaser-content")
      .find(".jobs-bulb-img img")
      .data("src");
    if (bulbSrc === bulbOffImg) {
      $(this)
        .parents(".jobs-teaser-content")
        .find(".jobs-bulb-img img")
        .attr("src", bulbOnSrc);
    } else {
      $(this)
        .parents(".jobs-teaser-content")
        .find(".jobs-bulb-img img")
        .attr("src", bulbOffImg);
    }

    var btnOffImg = jobTriggerImgOriginal;
    var btnImgSrc = $(this).find("img").attr("src");
    var btnOnSrc = $(this).find("img").data("src");
    if (btnImgSrc === btnOffImg) {
      $(this).find("img").attr("src", btnOnSrc);
    } else {
      $(this).find("img").attr("src", btnOffImg);
    }
  });

  // code for slider award slider
  if ($(".awards-slider").length) {
    var awardSlider = $(".awards-slider");
    if (awardSlider.find(".awards-slide").length > 5) {
      awardSlider.owlCarousel({
        items: 4,
        margin: 20,
        loop: true,
        dots: false,
        autoplay: true,
        nav: true,
        touchDrag: true,
        mouseDrag: true,
        autoplayTimeout: 4000,
        animateIn: "fadeIn",
        animateOut: "fadeOut",
        responsive: {
          0: {
            items: 2,
          },
          576: {
            items: 3,
          },
          992: {
            items: 4,
          },
        },
        onInitialize: function () {
          if (awardSlider.find(".awards-slide").length <= 5) {
            this.settings.loop = false;
            this.settings.nav = false;
            this.settings.autoplay = false;
          }
        },
      });
    } else {
      awardSlider.show();
    }
  }
  // code for testimonial  slider
  if ($(".testimonial-slider").length) {
    var testimonialSlider = $(".testimonial-slider");
    if (testimonialSlider.find(".testimonial-slide").length > 1) {
      testimonialSlider.owlCarousel({
        items: 1,
        loop: true,
        dots: false,
        autoplay: true,
        nav: true,
        touchDrag: true,
        mouseDrag: true,
        autoplayTimeout: 7000,
        onInitialize: function () {
          if (testimonialSlider.find(".testimonial-slide").length === 1) {
            this.settings.loop = false;
            this.settings.nav = false;
          }
        },
      });
    } else {
      testimonialSlider.show();
    }
  }

  $(".link-category-gallery .link-category-teaser").on("click", function (e) {
    e.preventDefault();
    $("#linkCategoryModal").modal("show");
  });

  wissen_flip();
  wissen_height();

  // code for pictureSlider  slider
  if ($(".picture-slider").length) {
    $(".picture-slider").each(function (index) {
      var pictureSlider = $(this);
      if (pictureSlider.find(".picture-slide").length > 1) {
        pictureSlider.owlCarousel({
          items: 1,
          loop: true,
          dots: false,
          autoplay: true,
          nav: true,
          touchDrag: true,
          mouseDrag: true,
          autoplayTimeout: 7000,
          onInitialize: function () {
            if (pictureSlider.find(".picture-slider").length === 1) {
              this.settings.loop = false;
              this.settings.nav = false;
            }
          },
        });
      } else {
        pictureSlider.show();
      }
    });
  }

  // Code for change URL regarding modal Id on browser
  var flag = true;
  var preHash = "";
  $(".category-teaser-linklist .link-category-teaser").on(
    "click",
    function (e) {
      var anchorLink = $(this).attr("href");
      console.log(anchorLink.substr(anchorLink.indexOf("#")));
      if (anchorLink.substr(anchorLink.indexOf("#")) === preHash) {
        flag = false;
      } else {
        var hashVal = anchorLink.substr(anchorLink.indexOf("#"));
        preHash = hashVal;
        if (!window.location.href.indexOf(hashVal) > -1) {
          window.location.hash = hashVal;
        } else {
          return false;
        }
      }
      // e.preventDefault();
    }
  );
  $(".category-modal.modal").on("hide.bs.modal", function (e) {
    let UrlLinkVal = window.location.href;
    var newUrl = UrlLinkVal;
    newUrl = newUrl.substr(0, newUrl.lastIndexOf("#"));
    window.history.replaceState({}, document.title, newUrl);
    preHash = "";
  });
});

// code for open modal
if (window.location.hash) {
  var hash = window.location.hash;
  if (hash.length) {
    if ($(hash).hasClass("modal")) {
      $(hash).modal("show");
    }
  }
}

var stickyOffset = $("header").height();
var previousScroll = 0;
$(window).scroll(function () {
  var scroll = $(window).scrollTop();
  // Fixed Menu
  if (scroll >= 300) {
    $("body").addClass("fixed-header");
  } else {
    $("body").removeClass("fixed-header");
  }

  /* for go to top arrow */
  var currentScroll = $(this).scrollTop();
  if (currentScroll > previousScroll) {
    if (scroll >= stickyOffset + 100) {
      $(".goto-top").addClass("visible");
    }
  } else {
    $(".goto-top").removeClass("visible");
  }

  if (scroll > $("header").height()) {
    $(".cta-wrapper").addClass("cta-active");
  } else {
    $(".cta-wrapper").removeClass("cta-active");
  }
});

$(window).resize(function () {
  banner_height();
  // wissen_flip();
});

var DELAY = 500,
  clicks = 0,
  timer = null;

function isTouchDevice() {
  return (
    true ==
    ("ontouchstart" in window ||
      (window.DocumentTouch && document instanceof DocumentTouch))
  );
}
$(document)
  .on("click", ".navigation .has-sub > a", function (e) {
    if (isTouchDevice() === true) {
      clicks++;
      if (clicks === 1) {
        timer = setTimeout(function () {
          clicks = 0;
        }, DELAY);
        e.preventDefault();
      } else {
        clearTimeout(timer);
        clicks = 0;
      }
    }
  })
  .on("dblclick", function (e) {});

//HIDE OPTIONS IF CLICKED ANYWHERE ELSE ON PAGE
$(document).on("touchstart click", function (e) {
  container = $(
    ".search-btn,.search-wrapper,.cta-link,.cta-img,.cta-wrapper, .partner-model-trigger, .vacancy-block-inner, .jobs-teaser-panel"
  );
  contactInfo = $(
    ".search-btn,.search-wrapper, .partner-info-modal .modal-body, .partner-logo-wrap, .vacancy-block-push-img, .btn-jobs-trigger, .navigation, .partner-info-box-wrap"
  );
  if (
    !container.is(e.target) &&
    container.has(e.target).length === 0 &&
    !contactInfo.is(e.target) &&
    contactInfo.has(e.target).length === 0
  ) {
    $(".cta-wrapper").removeClass("active");
    $(".search-wrapper").removeClass("search-active");
    $("html").removeClass("partner-model--open");
    $(".partner-info-box-wrap").removeClass("active");
    $(".vacancy-block-inner").slideUp();
    $(".jobs-teaser-panel").slideUp();
    $(".jobs-bulb-img img").attr("src", bulbOffImgOriginal);
    $(".btn-jobs-trigger img").attr("src", jobTriggerImgOriginal);
    $(".vacancy-block-push-img img").attr("src", pushBtnImgOriginal);
    $(".navigation li.has-sub").removeClass("has-sub--open");
  }
});
function win_height() {
  return $(window).outerHeight();
}
function win_width() {
  return $(window).width();
}
function header_height() {
  return $("header.page").outerHeight();
}
function banner_height() {
  if ($(window).width() > 992) {
    return $(".banner-section").css("height", win_height() - header_height());
  } else {
    return $(".banner-section").css("height", "auto");
  }
}
function wissen_height() {
  return $(".category-teaser-section").outerHeight();
}
function wissen_flip() {
  /* -------------------------------------------------------- */
  /*	//set Global variables
  /* -------------------------------------------------------- */
  var cards = $(".category-teaser-item"),
    toggler = cards.find(".link-category-toggle"),
    links = cards.find("li .link-category-teaser"),
    li = links.parent("li"),
    count = links.length,
    width = links.outerWidth();

  //set top margins & widths of li elements
  function setClosed() {
    li.each(function () {
      $(this)
        .css("top", 0)
        .css("width", "70%")
        .css("margin-left", "15%")
        .css("height", 0);
    });

    li.addClass("closed");
    cards.removeClass("expanded");
  }
  setClosed();

  /* -------------------------------------------------------- */
  /*	Toggler Click handler
  /* -------------------------------------------------------- */
  toggler.on("click", function () {
    var $this = $(this);
    //if the menu is expanded:
    (links = $this.parent().find("li .link-category-teaser")),
      (li = links.parent("li")),
      (count = links.length);

    //set z-Index of teaser Items
    links.parent("li").each(function (i) {
      $(this).css("z-index", count + i); //invert the index values
    });

    //if the menu is expanded:
    if (
      $this
        .parents(".col-md-6")
        .siblings()
        .find(".category-teaser-item")
        .is(".expanded")
    ) {
      setClosed();
    }
    if ($this.parents(".col-md-6").siblings().css("z-index", 10)) {
      $this.parents(".col-md-6").siblings().removeAttr("style");
    }

    //if the menu is un-expanded:
    $this.parent().toggleClass("expanded");
    li.removeClass("closed");
    visible = 10;

    //set top margins
    li.each(function (index) {
      $this.parents(".col-md-6").css("z-index", 10);
      // $this.parent().toggleClass("expanded");
      $(this)
        .css("height", 0)
        .css("top", index * 100)
        .css("width", width + index - 20)
        .css("margin-left", index + 10);
    });
    setTimeout(function () {
      if (
        $this.parents(".category-teaser-item").is(".expanded") ||
        $this
          .parents(".col-md-6")
          .siblings()
          .find(".category-teaser-item")
          .is(".expanded")
      ) {
        $this.parents(".category-teaser-section").css("overflow-y", "auto");
      } else {
        $this.parents(".category-teaser-section").css("overflow-y", "hidden");
        $(".category-teaser-section").scrollTop(0);
      }
    }, 300);
  });
  /* -------------------------------------------------------- */
  /*	Links Click handler
  /* -------------------------------------------------------- */
  links.on("click", function (e) {
    var $this = $(this);
    li.removeClass("active");
    if ($this.parent("li").is("active")) {
      $this.parent("li").removeClass("active");
    } else {
      $this.parent("li").addClass("active");
    }
    setClosed();
    e.preventDefault();
    $this.parents(".category-teaser-section").css("overflow", "auto");
  });

  if ($(window).width() > 1440) {
    toggler.on("click", function () {
      var $this = $(this); //cache $(this)
      //set top margins
      li.each(function (index) {
        $this.parents(".col-md-6").css("z-index", 10);
        $(this)
          .css("top", index * 160)
          .css("width", width + index + 60)
          .css("margin-left", index - 30);
      });
    });
  }
}
